import React from 'react';
import { motion } from 'framer-motion';
const bonuses = [{
  id: 1,
  title: 'Pack de Señales de Seguridad',
  description: 'Señales imprimibles, actividades guiadas y guía docente para enseñar señalización de forma práctica.',
  value: '$15',
  image: 'https://cdn.magicpatterns.com/uploads/tycWp1VQ96uRchuSCgBQxE/WhatsApp_Image_2026-01-03_at_21.26.10.jpg',
  color: 'border-orange-500',
  badgeColor: 'bg-orange-500',
  textColor: 'text-orange-600'
}, {
  id: 2,
  title: 'Kit Profesional de EPP',
  description: 'Selección, control y mantenimiento profesional de EPP. Todo lo que necesitás para enseñar protección personal.',
  value: '$15',
  image: 'https://cdn.magicpatterns.com/uploads/7Hfk4TFAmLrpBtAeGduh2b/WhatsApp_Image_2026-01-03_at_21.26.11.jpg',
  color: 'border-green-500',
  badgeColor: 'bg-green-500',
  textColor: 'text-green-600'
}, {
  id: 3,
  title: 'Kit de Simulacros y Emergencias',
  description: 'Guías, registros y afiches listos para ejecutar evacuaciones y emergencias en la escuela o taller.',
  value: '$19',
  image: 'https://cdn.magicpatterns.com/uploads/dHoEzV679FrSovnP8GZiQL/WhatsApp_Image_2026-01-03_at_21.26.11_(1).jpg',
  color: 'border-red-500',
  badgeColor: 'bg-red-500',
  textColor: 'text-red-600'
}];
export function BonusCards() {
  return <section className="py-20 bg-gradient-to-b from-gray-900 to-blue-900 text-white" data-id="element-24">
      <div className="container mx-auto px-4" data-id="element-25">
        <div className="text-center mb-16" data-id="element-26">
          <span className="inline-block px-4 py-1 bg-red-600 text-white font-bold rounded-full text-sm mb-4 animate-pulse" data-id="element-27">
            SOLO POR HOY
          </span>
          <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-28">
            Si te unís HOY, recibís estos{' '}
            <span className="text-yellow-400" data-id="element-29">BONOS GRATIS</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-30">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className={`bg-white text-gray-800 rounded-2xl overflow-hidden shadow-2xl border-b-8 ${bonus.color} flex flex-col`} data-id="element-31">
              <div className="relative overflow-hidden group p-4" data-id="element-32">
                <div className={`absolute top-6 right-6 ${bonus.badgeColor} text-white font-bold px-3 py-1 rounded-full text-sm z-10 shadow-md`} data-id="element-33">
                  GRATIS HOY
                </div>
                <div className="aspect-square w-full max-w-xs mx-auto" data-id="element-34">
                  <img src={bonus.image} alt={bonus.title} className="w-full h-full object-contain" data-id="element-35" />
                </div>
              </div>

              <div className="p-6 flex-1 flex flex-col" data-id="element-36">
                <div className={`text-sm font-bold uppercase tracking-wider mb-2 ${bonus.textColor}`} data-id="element-37">
                  BONO #{bonus.id}
                </div>
                <h3 className="text-xl font-bold mb-3" data-id="element-38">{bonus.title}</h3>
                <p className="text-gray-600 text-sm mb-6 flex-1" data-id="element-39">
                  {bonus.description}
                </p>

                <div className="flex items-end justify-between border-t border-gray-100 pt-4 mt-auto" data-id="element-40">
                  <div className="text-gray-400 text-sm font-medium" data-id="element-41">
                    Valor: <span className="line-through" data-id="element-42">{bonus.value}</span>
                  </div>
                  <div className={`text-2xl font-bold ${bonus.textColor}`} data-id="element-43">
                    HOY: $0
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}